import PopConfirm from './PopConfirm';

export default PopConfirm;



// WEBPACK FOOTER //
// ./src/components/grids/ViewUsersGrid/subComponents/PopConfirm/index.jsx